var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2636",
    "data-name": "Group 2636",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.001,
    height: 24,
    viewBox: "0 0 24.001 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_15872",
    "data-name": "Path 15872",
    d: "M38.13,43.17a12,12,0,1,1,12-12A12.015,12.015,0,0,1,38.13,43.17Zm0-22.857A10.857,10.857,0,1,0,48.988,31.17,10.87,10.87,0,0,0,38.13,20.313Z",
    transform: "translate(-26.13 -19.17)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_15873",
    "data-name": "Path 15873",
    d: "M56.028,41.914c.477-.015.951,0,1.428,0h.2V39.343c-.255-.026-.521-.064-.787-.079-.488-.023-.976-.049-1.465-.038a3.506,3.506,0,0,0-2.07.662,3.234,3.234,0,0,0-1.242,2.144,7.955,7.955,0,0,0-.087,1.1c-.015.575,0,1.153,0,1.732v.216H49.63v2.87h2.354v7.214h2.882v-7.2h2.346c.12-.953.237-1.9.361-2.881h-.528c-.667,0-2.2,0-2.2,0s.007-1.422.022-2.038A1.042,1.042,0,0,1,56.028,41.914Z",
    transform: "translate(-41.772 -35.436)",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.1417ce55a54d49bb3def595450a3f8f1.svg";
export { ForwardRef as ReactComponent };